import React, { useState } from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import UserFeedbackPicker
  from 'Components/ComponentLibrary/Organisms/UserFeedback/UserFeedbackPicker/UserFeedbackPicker';

const useStyles = buildUseStyles('UserFeedback', (() => ({
  root: {},
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 33,
  },
})));

const UserFeedback = ({ className, ...rest }) => {
  const [hasSubmittedFeedback, setHasSubmittedFeedback] = useState(false);

  const classes = useStyles();
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <UserFeedbackPicker
        className={classes.row}
        hasSubmittedFeedback={hasSubmittedFeedback}
        setHasSubmittedFeedback={setHasSubmittedFeedback}
        {...rest}
      />
    </Box>
  );
};

UserFeedback.defaultProps = {
  className: '',
  onFeedbackSubmitted: undefined,
};

UserFeedback.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string.isRequired,
  onFeedbackSubmitted: PropTypes.func,
};

export default UserFeedback;
